import { render, staticRenderFns } from "./MassDelete.vue?vue&type=template&id=087e7b60&"
import script from "./MassDelete.vue?vue&type=script&lang=js&"
export * from "./MassDelete.vue?vue&type=script&lang=js&"
import style0 from "./MassDelete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports